exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_settings_sDSHr_wXFRfiEXZ0QVCQc {\n  width: 100%;\n  float: left;\n  clear: both;\n  box-sizing: border-box;\n}\n\n.IA_settings_sDSHr_wXFRfiEXZ0QVCQc h3 {\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n\n.IA_settings_error_message_1v4AvRaAYGWn7qRGGWnRIx {\n  color: red;\n  margin-top: 10px;\n}\n\n.IA_notification_toggle_text_2Iv6O7GlE0sCK9dDrOB2Mi {\n  font-size: 12px;\n  color: gray;\n  display: inline-block;\n}", ""]);

// Exports
exports.locals = {
	"IA_settings": "IA_settings_sDSHr_wXFRfiEXZ0QVCQc",
	"IA_settings_error_message": "IA_settings_error_message_1v4AvRaAYGWn7qRGGWnRIx",
	"IA_notification_toggle_text": "IA_notification_toggle_text_2Iv6O7GlE0sCK9dDrOB2Mi"
};